module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle1"
  }, [_vm._v("Abbreviations Used in the Notes")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("ACHS: Adams County Historical Society, Gettysburg, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("ANV: Army of Northern Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("AOP: Army of the Potomac")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("BSF: Brandy Station Foundation, Brandy Station, VA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("C&O: Chesapeake & Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("CCHS: Cumberland County Historical Society, Carlisle, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("CV: Confederate Veteran")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("CWTI: Civil War Times Illustrated")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("FSNMP: Fredericksburg and Spotsylvania Military Park, Fredericksburg, VA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("GNMP: Gettysburg National Military Park, Gettysburg, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("HL: Huntington Library, San Marino, CA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("HSOPRF: Historical Society of Oak Park and River Forest, IL")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("HSP: Historical Society of Pennsylvania, Philadelphia, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("JCPL: Jasper County Public Library, Rensselaer, IN")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("JMSIUS: Journal of the Military Service Institution of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("KHS: Kittochtinny Historical Society, Chambersburg, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("LCHS: Lancaster County Historical Society, Lancaster, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("LOC: Library of Congress, Washington, DC")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("MDAH: Mississippi Department of Archives and History, Jackson, MS")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("MGRR: Manassas Gap Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("MHACV: Mennonite Historical Association of the Cumberland Valley, Chambersburg, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("MOLLUS: Military Order of the Loyal Legion of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("NARA: National Archives and Records Administration, Washington, DC")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("NCSA: North Carolina State Archives, Raleigh, NC")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("NT: The National Tribune")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("NYSNG: New York State National Guard")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("OR: Official Records of the War of the Rebellion")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("PRR: Pennsylvania Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("SCV: Sons of Confederate Veterans")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("SHC-UNC: Southern Historical Collection, Wilson Library, Univ. of North Carolina, Chapel Hill")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("SHSP: Southern Historical Society Papers")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("UGA: Univ. of Georgia, Athens, GA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("UM: Univ. of Michigan, Ann Arbor, MI")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("UNC: Univ. of North Carolina, Chapel Hill, NC")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("USAHEC: United States Army Heritage and Education Center, Carlisle, PA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("UVA: Univ. of Virginia, Charlottesville, VA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("VHS: Virginia Historical Society, Richmond, VA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("VMI: Virginia Military Institute, Lexington, VA")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("VOTS: Valley of the Sun, a Civil War website of the Univ. of Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("YCHC: York County History Center, York, PA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b3a97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abbreviations.vue
// module id = 75
// module chunks = 0